export default __webpack_public_path__ + "static/media/030_corner_good.9d2b29a3.mp3";